<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>资产明细管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="团长姓名">
        <el-input size="small" clearable v-model="formInline.leaderName" placeholder="请输入团长姓名"></el-input>
      </el-form-item>
            <el-form-item label="团长手机号码">
              <el-input size="small" clearable v-model="formInline.leaderPhone" placeholder="请输入团长手机号码"></el-input>
            </el-form-item>
      <el-form-item label="团长等级">
        <el-input size="small" clearable v-model="formInline.leaderGrade" placeholder="请输入团长等级"></el-input>
      </el-form-item>
      <!--      <el-form-item label="物流单号">-->
      <!--        <el-input size="small" clearable v-model="formInline.logisticsNo" placeholder="请输入物流单号"></el-input>-->
      <!--      </el-form-item>-->
<!--      <el-form-item label="主订单编号">-->
<!--        <el-input size="small" clearable v-model="formInline.outTradeNo" placeholder="请输入订单编号"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="交易状态">-->
<!--        <el-select size="small" clearable filterable v-model="formInline.payState" placeholder="请选择交易状态">-->
<!--          <el-option-->
<!--            v-for="company in dealList"-->
<!--            :key="company.value"-->
<!--            :label="company.key"-->
<!--            :value="company.value"-->
<!--          ></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <el-form-item label="人员归属">
        <el-select size="small" clearable filterable v-model="formInline.delegationOfHead" placeholder="请选择人员归属">
          <el-option
            v-for="company in delegationHeadOpts"
            :key="company.value"
            :label="company.key"
            :value="company.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="明细时间（月）">
        <el-date-picker
          size="small"
          v-model="formInline.searchMonth"
          value-format="yyyy-MM"
          type="month"

          placeholder="选择月份">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-row style="margin-bottom: 10px">
      <el-button size="small" type="info" plain icon="el-icon-upload2" @click="handleExport">导出</el-button>
    </el-row>
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" @selection-change="selectChange" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="50">
      </el-table-column>
      <el-table-column prop="leaderName" label="团长姓名" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="leaderGrade" label="团长等级" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="affiliatedStore" label="所在门店" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="delegationHeadCn" label="人员归属" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="phoneNumber" label="手机号	" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="shareDetailId" label="订单编号"  show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="payUserName" label="购买人姓名" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="commission" label="获得佣金" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="orderCreateDate" label="下单时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="accountDate" label="佣金到账时间" width="140" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
<!--    <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @close="closeDialog('exportForm')">-->
<!--      <el-form label-width="120px" :model="exportForm" ref="exportForm" :inline="true">-->

<!--        <el-form-item label="订单状态">-->
<!--          <el-select size="small" v-model="exportForm.tradeState" placeholder="请选择订单状态" >-->
<!--            <el-option-->
<!--              v-for="company in payway"-->
<!--              :key="company.value"-->
<!--              :label="company.key"-->
<!--              :value="company.value"-->
<!--            ></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="订单归属云仓">-->

<!--          <el-select size="small" v-model="exportForm.thirdFlag" placeholder="请选择归属云仓" >-->
<!--            <el-option-->
<!--              v-for="company in productSource"-->
<!--              :key="company.value"-->
<!--              :label="company.key"-->
<!--              :value="company.id"-->
<!--            ></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="时间选择">-->
<!--          <el-date-picker-->
<!--            size="small"-->
<!--            v-model="dateRange2"-->
<!--            type="daterange"-->
<!--            @change="dateChange2"-->
<!--            value-format="yyyy-MM-dd"-->
<!--            range-separator="至"-->
<!--            start-placeholder="开始日期"-->
<!--            end-placeholder="结束日期">-->
<!--          </el-date-picker>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--      <div slot="footer" class="dialog-footer">-->
<!--        <el-button size="small" @click="closeDialog('exportForm')">取消</el-button>-->
<!--        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('exportForm')">导出</el-button>-->
<!--      </div>-->
<!--    </el-dialog>-->
  </div>
</template>

<script>
import { assetList, detailsExport } from '../../api/leader'
import Pagination from '../../components/Pagination'
import {Loading} from "element-ui";
import exportFile from '@/utils/exportFile'
import {getDictByTypeId} from "../../api/system";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      companyOption:[],
      delegationHeadOpts:[{
        key:'国药',
      value:0}, {key:'普通',
        value:1}],
      payway: [
        { key: '待付款', value: 'PAID' },
        { key: '待发货', value: 'SHIPPED' },
        { key: '待收货', value: 'RECEIVED' },
        // { key: '待评价', value: 'EVALUATED' },
        { key: '已取消', value: 'CANCEL' },
        // { key: '支付失败', value: 'PAYERROR' },
        { key: '退货退款中', value: 'REFUNDGOODING' },
        { key: '退货退款成功', value: 'REFUNDGOOD' },
        { key: '退货退款失败', value: 'REFUNDGOODERR' },
        { key: '退款成功', value: 'REFUND' },
        { key: '订单完成', value: 'POSTSALE' },
        { key: '退款中', value: 'REFUNDING' },
      ],
      // thirdFlagList:[
      // ],
      productSource:[],
      dealList:[
        {
          key:'未支付',value:'0'
        },
        {
          key:'已支付',value:'1'
        },
        {
          key:'已取消',value:'2'
        },
      ],
      dateRange:null,
      dateRange2:null,
      editForm: {
        id: '',
      },
      formInline: {
        pageNum: 1,
        pageSize: 10,
        searchMonth:null,
        delegationOfHead:null,
        leaderPhone:null,
        leaderName:null,
        leaderGrade:null
      },
      exportForm:{
        tradeState:null,
        thirdFlag:null,
        startDate: '',
        endDate: '',
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      ids: '',
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    this.getdata(this.formInline);
    this.getDict()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取快递公司列表
    getCompanyList(){
      return findExpreCompany().then(res=>{
        return this.companyOption = res.body
      })
    },
    //获取字典数据
    getDict() {
      this.getDictById(32)
    },
    async getDictById(id) {
      const {body} =  await getDictByTypeId(id)
      this.productSource = body
    },
    dateChange(v){
      console.log(v);
      this.formInline.startDate	= v[0]
      this.formInline.endDate	= v[1]
    },
    dateChange2(v){
      console.log(v);
      this.exportForm.startDate	= v[0]
      this.exportForm.endDate	= v[1]
    },
    // 获取表格数据
    getdata(parameter) {
      this.loading = true
      assetList(parameter)
        .then(res => {
          this.loading = false
          console.log(res.rsp_code)
          if (res.rsp_code !== 200) {
            this.$message({
              type: 'info',
              message: res.rsp_msg
            })
          } else {
            this.listData = res.rows
            console.log(this.listData);
            // 分页赋值
            this.pageparm.currentPage = this.formInline.pageNum
            this.pageparm.pageSize = this.formInline.pageSize
            this.pageparm.total = res.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.pageNum=1
      this.getdata(this.formInline)
    },
    // selection选择
    selectChange(selection) {
      // console.log('selection',selection);
      // if (selection.length > 0) {
      //   this.isGroundingBtn = false
      // } else {
      //   this.isGroundingBtn = true
      // }
      let ids;
      ids = selection.map(item => item.id)
      this.ids = ids.join()
    },


    getStatus(statusOption,statusName){
      let statusObj = statusOption.filter( statusItem => statusName == statusItem.value )
      return statusObj[0].key
    },
    /** 导出按钮操作 */
    handleExport() {
      // this.download('system/goods/export', {
      //   ...this.queryParams
      // }, `goods_${new Date().getTime()}.xlsx`)
      let downloadLoadingInstance;
      downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      detailsExport({...this.formInline}).then(res => {
        exportFile.getExcel(res, `assetList_${new Date().getTime()}`)
        downloadLoadingInstance.close()
      }).catch(() => {
        downloadLoadingInstance.close()
      })
    },
    routerChild() {
      let that = this;
      that.$router.push({
        path: "/pay/Order/childrenOrder"
      });
    }
  }
}
</script>

<style scoped>
.el-select{
  width: 100%;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/pay/commission.vue